export enum StampCardSorter {
    IssuedAtDesc = 'IssuedAtDesc',
    ShopNameAsc = 'ShopNameAsc'
}

export type StampEventType =
    'ISSUED'
    | 'USED'
    | 'CANCELED'
    | 'EXPIRED';

export type RewardTargetScope = 'SHOP' | 'SHOP_GROUP' | 'PROJECT';

export type CouponIssueType = 'AUTO' | 'MANUAL';
